/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResourceTaskPatternType {
    Base = '0',
    Offset = 1,
}
